import { render, staticRenderFns } from "./FinalGradeSelectReviewersTable.vue?vue&type=template&id=2590d29a&"
import script from "./FinalGradeSelectReviewersTable.vue?vue&type=script&lang=js&"
export * from "./FinalGradeSelectReviewersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports